<script lang="ts">
  import type { Snippet } from 'svelte';
  import { fa } from '../i18n/fa';
  import Button from './Button.svelte';

  /** The only modal (ADR-016): a short confirmation of one consequential command. */
  let {
    open,
    title,
    children,
    confirmLabel,
    tone = 'primary',
    loading,
    onConfirm,
    onCancel,
  }: {
    open: boolean;
    title: string;
    children?: Snippet;
    confirmLabel: string;
    tone?: 'primary' | 'danger';
    loading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
  } = $props();
  const titleId = $props.id();

  let dialog = $state<HTMLDialogElement>();
  $effect(() => {
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  });
</script>

<dialog
  bind:this={dialog}
  oncancel={(e) => {
    // The browser closes it (and `close` reports it), except while the action runs.
    if (loading) e.preventDefault();
  }}
  onclose={() => {
    if (open && !dialog?.open) onCancel();
  }}
  aria-labelledby={titleId}
  class="pop-enter m-auto w-[min(92vw,420px)] rounded-xl border border-[var(--neu-edge)] bg-surface p-0 text-text shadow-raised-lg backdrop:bg-[var(--scrim)]"
>
  {#if open}
    <div class="p-5">
      <h2 id={titleId} class="text-lg font-bold">{title}</h2>
      {#if children}<div class="mt-3 text-sm text-text-2">{@render children()}</div>{/if}
      <div class="mt-5 flex flex-wrap justify-end gap-2">
        <Button variant="secondary" onclick={onCancel} disabled={loading}>{fa.app.cancel}</Button>
        <Button variant={tone} onclick={onConfirm} {loading}>{confirmLabel}</Button>
      </div>
    </div>
  {/if}
</dialog>
